import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { VersionsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { VersionsNew } from "./new";
import { VersionsTable } from "./table";

export default function Versions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Versions");
  }, []);

  return (
    <Routes>
      <Route index element={<VersionsTable />} />
      <Route path="new" element={<VersionsNew />} />
      <Route path=":id" element={<VersionsCard />} />
    </Routes>
  );
}
